import React, { useEffect, useState } from "react";
import "../index.css";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";
import {
  getDateWithoutMonthName,
  searchFilter,
  handleSort,
  getToday,
  getDate,
  investmentDetailsPath,
  investmentPath,
  addProspectTaskPath,
  investorCreateEmailPath,
} from "../utils/varialbles";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
// import CommunicationTimeLine from './communicationTimeline';
import CommunicationTimeLine from "../prospect/communicationTimeline";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CallIcon from "@material-ui/icons/Call";
import EmailIcon from "@material-ui/icons/Email";
import { prospectDetailsPath } from "../utils/varialbles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    //minWidth:150,
    border: "1px solid green",
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
let form = {
  mobile: "",
  countrycode: "91",
  fname: "",
  lname: "",
  email: "",
  reason: 1,
  getbackdate: "",
  comment: "",
  enquiry: 1,
  communication: 1,
  interest: 1,
  reason_notinterest: "",
  politeness: 1,
  family_background: "",
  goal: "",
  previous_investment: 1,
  inv_exp: "",
  broker_quantum: "",
  advisor_quantum: "",
  loc_state: "",
  loc_country: "",
  bgt: "N/A",
  crt: "",
  checkin_status: "",
  bgtStatus: "",
  cdt_status: "",
  crt_status: "",
};
function EditInvestornew() {
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  // (questionner);
  const location = useLocation();
  const [countryDropDown, setcountryDropDown] = useState([]);
  const [cdtStatusDropDown, setCdtStatusDropDown] = useState([]);
  const [checkInStatusDropdown, setCheckInStatusDropdown] = useState([]);
  const [validationState, setValidationState] = useState({});
  const [cdtStatusNew, setCdtStatusNew] = useState("");
  const [checkInStatusNew, setCheckInStatusNew] = useState("");
  const [CRTstatus, setCRTstatus] = useState("");
  const [dropdownCRTstatus, setdropdownCRTstatus] = useState([]);

  const [taskDetails, setTaskDetails] = useState([]);
  // (taskDetails);
  const [rmNames, setRmNames] = useState([]);
  const [crtName, setcrtName] = useState([]);
  // (rmNames);

  const [settingdata, setSettingdata] = useState({
    Assign_exe_value: "",
    Assign_exe_value_crt: "",
  });

  const [setcustid, setshowcustid] = useState("");

  const validations = {
    mobile: {
      conditions: {
        required: false,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },
    communication: {
      conditions: {
        required: false,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },
    fname: {
      conditions: {
        required: false,
        maxLength: 20,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    lname: {
      conditions: {
        required: false,
        maxLength: 20,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    comment: {
      conditions: {
        required: false,
        maxWordLength: 500,
        delimiter: " ",
      },
      message: "Maximum 500 Words Allowed.!",
      valid: true,
      changed: false,
    },
  };
  const myparam = location.state;

  const reasonMapper = {
    1: "Requested for sign up but did not do it",
    2: "Left Abruptly",
    3: "Other reason",
  };
  const reasonReverseMapper = {
    "Requested for sign up but did not do it": "1",
    "Left Abruptly": "2",
    "Other reason": "3",
  };
  const [formObject, setFromObject] = useState(form);
  console.log(formObject);
  //alert(formObject.communication);
  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    // { "lable": "How did you get to know about Savart?", "imp":false, "filedType": "dropDown", "value": "enquiry", "display": true },
    {
      lable: "Communication Preference",
      imp: false,
      filedType: "dropDown",
      value: "communication",
      display: false,
    },
    // { "lable": "Was he/ She interested in the services?", "imp":false, "filedType": "dropDown", "value": "interest", "display": true, "boolean": true },
    // { "lable": "If not interested, what was the reason for disinterest?", "imp":false, "filedType": "text", "value": "reason_notinterest", "display": true,disableCondition:"interest",disableValue:1  },
    // { "lable": "Was he/ She polite with communication", "imp":false, "filedType": "dropDown", "value": "politeness", "display": true, "boolean": true },
    // { "lable": "Family background", "imp":false, "filedType": "text", "value": "family_background", "display": true },
    // { "lable": "Goal Details", "imp":false, "filedType": "text", "value": "goal", "display": true },
    // { "lable": "Have you ever invested before?", "imp":false, "filedType": "dropDown", "value": "previous_investment", "display": true, "boolean": false },
    // { "lable": "If yes, How was your experience?", "imp":false, "filedType": "text", "value": "inv_exp", "display": true,disableCondition:"previous_investment",disableValue:4 },
    // { "lable": "If yes, with which broker? what was the quantum?", "imp":false, "filedType": "text", "value": "broker_quantum", "display": true,disableCondition:"previous_investment",disableValue:4 },
    // { "lable": "If yes, with which adivisor? what was the quantum?", "imp":false, "filedType": "text", "value": "advisor_quantum", "display": true,disableCondition:"previous_investment",disableValue:4 },
    // { "lable": "Status", "imp":false, "filedType": "dropDown", "value": "status", "display": false },
    // { "lable": "Country", "imp":false, "filedType": "dropDown", "value": "loc_country", "display": false }

    // { "lable": "Prospect Location", "imp":false, "filedType": "dropDown" ,"value":"loc_country"},
  ];
  const classes = useStyles();
  const getDropdownValue = (field, text, boolean, data) => {
    // (field);
    // (text);
    // (boolean);
    // (data);
    if (text) {
      let CurrentQuestion = userQuestionnaire.filter((obj) => {
        return obj["value"] === field;
      });
      let current = [];
      if (CurrentQuestion && CurrentQuestion.length > 0) {
        current = data.filter((obj) => {
          return obj["question"] === CurrentQuestion[0]["lable"];
        });
      }
      if (boolean && text && text === true) {
        return 1;
      } else if (boolean && !text) {
        return 2;
      } else if (current && current.length > 0) {
        let value = current[0].options.filter((option) => {
          return option.name === text;
        });
        if (value.length > 0) {
          return value[0]["values"];
        } else {
          return 1;
        }
      } else {
        // return 1;
        return "";
      }
    } else {
      if (boolean && !text) {
        return 2;
      } else {
        // return 1;
        return "";
      }
    }
  };

  const handleCancel = () => {
    if (myparam && myparam.customer_id) {
      http
        .get("/edit_investor_details/" + myparam.customer_id)
        .then((response) => {
          // (response);
          if (response.data.statusCode === 0) {
            if (
              response.data &&
              response.data.Dropdowns &&
              Array.isArray(response.data.Dropdowns) &&
              response.data.Dropdowns.length > 0
            ) {
              setQuestionner(response.data.Dropdowns);
            }
            let countryList = response.data.Dropdowns.filter((obj) => {
              return obj.question === "Country";
            });
            if (
              countryList &&
              countryList.length > 0 &&
              countryList[0]["options"] &&
              Array.isArray(countryList[0]["options"])
            ) {
              setcountryDropDown(countryList[0]["options"]);
            }

            if (
              response.data &&
              response.data.data &&
              Array.isArray(response.data.data) &&
              response.data.data.length > 0
            ) {
              let questionData = {};
              let userData = {};
              let userDetails = {};

              if (
                response.data &&
                response.data.Questionnaire &&
                Array.isArray(response.data.Questionnaire) &&
                response.data.Questionnaire.length > 0
              ) {
                questionData = response.data.Questionnaire[0];
                console.log(response.data.Questionnaire[0].communication, 'fghj');
                let userData = response.data.data[0];

                let updatedForm = {
                  mobile: userData.cust__custregmobile,
                  countrycode: userData.cust__custcountrycode,
                  fname: userData.cust__custfirstname,
                  lname: userData.cust__custlastname,
                  email: userData.cust__custemail,
                  assigned_exec: userData.assigned_exec,
                  crt: userData.crt,
                  bgt: userData.bgt,
                  signup: getDateWithoutMonthName(userData.signup),
                  cdt_status:
                    userData.cdt_status !== "No Status"
                      ? userData.cdt_status
                      : "",
                  crt_status:
                    userData.crt_status !== "No Status"
                      ? userData.crt_status
                      : "",
                  checkin_status:
                    userData.checkin_status !== "No Status"
                      ? userData.checkin_status
                      : "",
                  bgtStatus:
                    userData.status !== "No Status" ? userData.status : "",
                  communication: getDropdownValue(
                    "communication",
                    questionData.communication,
                    false,
                    response.data.Dropdowns
                  ),
                  loc_state: questionData.loc_state,
                  loc_country: userData.cust__custcountry__locname,
                };
                // (updatedForm);
                setFromObject(updatedForm);
                console.log(updatedForm, "updatedForm");
              } else if (response.data.data[0]) {
                // questionData = response.data.Questionnaire[0];
                userDetails = response.data.data[0];
                let detailsForm = {
                  mobile: userDetails.cust__custregmobile,
                  countrycode: userDetails.cust__custcountrycode,
                  fname: userDetails.cust__custfirstname,
                  lname: userDetails.cust__custlastname,
                  email: userDetails.cust__custemail,
                  assigned_exec: userDetails.assigned_exec,
                  signup: getDateWithoutMonthName(userDetails.signup),
                  bgt: userDetails.bgt,
                  crt: userDetails.crt,
                  cdt_status:
                    userDetails.cdt_status !== "No Status"
                      ? userDetails.cdt_status
                      : "",
                  crt_status:
                    userDetails.crt_status !== "No Status"
                      ? userDetails.crt_status
                      : "",
                  checkin_status:
                    userDetails.checkin_status !== "No Status"
                      ? userDetails.checkin_status
                      : "",
                  // "status": "Interested",
                  communication:
                    questionData && questionData.communication
                      ? getDropdownValue(
                          "communication",
                          questionData.communication,
                          false,
                          response.data.Dropdowns
                        )
                      : 2,
                  // "communication": 2,
                  loc_state: userDetails.loc_state
                    ? userDetails.loc_state
                    : null,
                  // "loc_state": "Andhra",
                  loc_country: userDetails.cust__custcountry__locnam
                    ? userDetails.cust__custcountry__locnam
                    : "India",
                };

                // (detailsForm);
                setFromObject(detailsForm);
                console.log(detailsForm, "detailsForm");
              }
            }
          } else {
            toast.error("Failed to Get Prospect Dropdowns..!");
            history.goBack();
          }
        })
        .catch((error) => {
          console.log("error");
        });
    } else {
      history.goBack();
    }
  };
  useEffect(() => {
    setValidationState(validations);
    handleCancel();
  }, []);

  useEffect(() => {
    let customer_id = myparam.customer_id;
    http
      .get(`/gettasks/${customer_id}`)
      .then((response) => {
        // (response);
        // let data=res.data;
        // let mapData=data.map((obj, index)=>{
        //     // (obj);
        // })
        if (
          response.data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          setTaskDetails(response.data.Data);
          // (response.data.Data);
        } else {
          setTaskDetails([]);
        }
        // (res);
        // (res.data);
      })
      .catch((err) => {
        // (err);
      });
  }, []);

  const [staTuss, setstaTuss] = useState("");
  // (staTuss);

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    var getValue = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    let validation = null;
    if (name && validStateTemp.hasOwnProperty(name)) {
      if (
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionalRequired"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionField") &&
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionOperator"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionValue") &&
        formObject.hasOwnProperty(
          validStateTemp[name]["conditions"]["conditionField"]
        )
      ) {
        validStateTemp[name]["conditions"]["conditionFieldValue"] =
          formObject[validStateTemp[name]["conditions"]["conditionField"]];
        validation = handleValidation(name, getValue, validStateTemp);
      } else {
        validation = handleValidation(name, getValue, validStateTemp);
      }

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || getValue === "" || getValue === 0) {
      let finalObjet = { ...formObject };
      finalObjet[name] = getValue;
      let validStateTemp = { ...validationState };
      let validData = handleSubmitValidation(finalObjet, validStateTemp);
      setValidationState(validData.validStateTemp);
      let setObject = { ...formObject };
      if (name === "previous_investment" && getValue === 4) {
        setObject["inv_exp"] = "";
        setObject["broker_quantum"] = "";
        setObject["advisor_quantum"] = "";
        setObject["previous_investment"] = getValue;
        setFromObject(setObject);
      } else {
        setFromObject({
          ...formObject,
          [event.target.name]: event.target.value,
        });
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    if (cdtStatusNew !== "") {
      finalObjet.cdt_status = cdtStatusNew;
    } else if (finalObjet.cdt_status === "") {
      finalObjet.cdt_status = null;
    } else {
      let getUnchangedStatus = cdtStatusDropDown.filter((item) => {
        return item.name === formObject.cdt_status;
      });
      // delete finalObjet.status
      finalObjet.cdt_status = getUnchangedStatus[0].value;
    }

    if (CRTstatus !== "") {
      finalObjet.crt_status = CRTstatus;
    } else if (finalObjet.crt_status === "") {
      finalObjet.crt_status = null;
    } else {
      let getCRTstatus = dropdownCRTstatus.filter((item) => {
        return item.name === formObject.crt_status;
      });
      console.log(getCRTstatus, "getCRTstatus");
      // delete finalObjet.status
      finalObjet.crt_status = getCRTstatus[0].value;
    }

    if (checkInStatusNew !== "") {
      finalObjet.checkin_status = checkInStatusNew;
    } else if (finalObjet.checkin_status === "") {
      finalObjet.checkin_status = null;
    } else {
      let getcheckInStatus = checkInStatusDropdown.filter((item) => {
        return item.name === formObject.checkin_status;
      });
      // delete finalObjet.status
      finalObjet.checkin_status = getcheckInStatus[0].value;
    }

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (validCount === 0) {
      userQuestionnaire.map((obj) => {
        let filter = [];
        if (obj["filedType"] == "dropDown" && !obj["boolean"]) {
          filter = questionner.filter((question) => {
            return question.question === obj.lable;
          });
          if (filter.length > 0) {
            let value = filter[0].options.filter((option) => {
              return option.values === finalObjet[obj.value];
            });
            if (value.length > 0) {
              finalObjet[obj.value] = value[0]["name"];
            }
          }
        }

        if (obj["boolean"] && finalObjet[obj.value] != 1) {
          finalObjet[obj.value] = 0;
        }
      });

      finalObjet["status"] = staTuss ? staTuss : "P";
      Object.keys(finalObjet).map((key) => {
        finalObjet[key] = finalObjet[key] === "" ? null : finalObjet[key];
      });

      http
        .post("/edit_investor_details/" + myparam.customer_id + "/", finalObjet)
        .then((response) => {
          if (response.data.statusCode === 0) {
            toast.success(response.data.data);
            // (response.data.data);
            if (myparam && myparam.customer_id) {
              history.push({
                pathname: investmentDetailsPath,
                state: myparam,
              });
            }
            handleCancel();
          } else {
            toast.error(response.data.data);
          }
          setFromObject({
            ...formObject,
            addProspectBtnClick: false,
          });
          // setFromObject(form)
        })
        .catch((error) => {
          console.log("error");
        });
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };

  const investdetails = (e) => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };

  const handleChangeAssignExe = (event) => {
    setSettingdata({
      ...settingdata,
      Assign_exe_value: event.target.value,
    });

    let cust_id = myparam.customer_id;
    setshowcustid(cust_id);

    const postdata = {
      emp_id: event.target.value,
      cust_id: cust_id,
    };
    let empid = postdata.emp_id;
    let cutid = postdata.cust_id;
    const baserm = "/rmchangeinv";
    http
      .post(`${baserm}?emp_id=${empid}&cust_id=${cutid}`, postdata)
      .then((res) => {
        // (res);
        toast.success(res.data.rms);
      })
      .catch((err) => {
        // (err);
      });
  };
  const handleChangeAssigncrt = (event) => {
    setSettingdata({
      ...settingdata,
      Assign_exe_value_crt: event.target.value,
    });
    let cust_id = myparam.customer_id;
    setshowcustid(cust_id);

    const postdata = {
      emp_id: event.target.value,
      cust_id: cust_id,
    };
    let empid = postdata.emp_id;
    let cutid = postdata.cust_id;
    const baserm = "/rmchangeinv";
    http
      .post(`${baserm}?emp_id=${empid}&cust_id=${cutid}`, postdata)
      .then((res) => {
        // (res);
        toast.success(res.data.rms);
      })
      .catch((err) => {
        // (err);
      });
  };

  useEffect(() => {
    rmChangeList();
    if (myparam && myparam.cust__id) {
      let cust_id = myparam.cust__id;
      setshowcustid(cust_id);
    }
  }, []);
  const rmChangeList = () => {
    http
      .get("/rmchangeinv")
      .then((res) => {
        // (res.data.rms);
        setRmNames(res.data.rms);
        setcrtName(res.data.crt);
        setCdtStatusDropDown(res.data.status);
        setCheckInStatusDropdown(res.data.checkin);
        setdropdownCRTstatus(res.data.crt_status);
      })
      .catch((err) => {
        // (err);
      });
  };

  const addTask = (e) => {
    e.preventDefault();
    if (myparam && myparam.customer_id) {
      // (myparam.customer_id);
      history.push({
        pathname: addProspectTaskPath,
        state: myparam,
      });
    }
  };

  const [callBtnDisable, setCallBtnDisable] = useState(false);

  const callCustomer = (e, taskno, comments) => {
    e.preventDefault();
    // (taskno);
    if (myparam && myparam.customer_id) {
      setCallBtnDisable(true);
      http
        .get("/callrequest?cust_id=" + myparam.customer_id + "&location=I")
        .then((res) => {
          if (res && res.data && res.data.Data && res.data.statusCode === 0) {
            toast.success(
              "Call Request Placed successfully,Please wait for the call..!"
            );

            http
              .patch("/updatetaskstatus/" + taskno + "/")
              .then((res) => {
                // (res);
              })
              .catch((err) => {
                // (err);
              });
          } else {
            toast.error("Call Request Failed");
          }
        })
        .catch((err) => {
          toast.error("Call Request Failed");
        });
    }
  };

  const sendEmail = (e, taskno, commments) => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorCreateEmailPath,
        state: myparam,
        task: taskno,
        comments: commments,
      });
    }
  };

  const [baseFile, setBaseFile] = useState({
    dataproof: "",
    cust: "",
  });

  const { cust, dataproof } = baseFile;

  // (baseFile.dataproof);

  const handleImageChange = async (e, taskno) => {
    //alert("file received");
    const file = e.target.files[0];
    // (file);
    // (file.name);
    const base64 = await convertBase64(file);
    setBaseFile({ ...baseFile, dataproof: base64 });
    // sendfile(e, taskno, base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  var today = new Date();
  var dd = String(today.getDate());
  var mm = String(today.getMonth());
  var yyyy = today.getFullYear();
  let todaydate = yyyy + "-" + mm + "-" + dd;

  const sendfile = (e, taskno, comments) => {
    const sendBase64 = {
      proof: dataproof,
      cust: cust,
      date: todaydate,
      communicationmode: "WhatsApp Call",
      duration: "0",
      time: "00:00",
      comments: comments,
    };
    http.post("/addcommunicationlog", sendBase64).then((res) => {
      // (res);
      if (res.data.Data && res.data.Data !== "Exception") {
        http
          .patch("/updatetaskstatus/" + taskno + "/")
          .then((res) => {
            // (res);
          })
          .catch((err) => {
            // (err);
          });
      }
    });
  };

  useEffect(() => {
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      let cust_id = myparam.cust__id || myparam.customer_id;
      // setFromObject(form);
      setBaseFile({
        ...baseFile,
        cust: cust_id,
      });
    }
  }, []);

  const handleChangeCheckInStatus = (event) => {
    setCheckInStatusNew(event.target.value);
  };
  const handleChangeCdtStatus = (event) => {
    setCdtStatusNew(event.target.value);
  };

  const handleCRTstatus = (event) => {
    setCRTstatus(event.target.value);
  };

  console.log(formObject.communication, 'fc');

  return (
    <>
      <div className="edithead">
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          style={{ height: "40px" }}
          onClick={investdetails}
        >
          Back
        </Button>
        <h3>User Info</h3>
        <Button
          variant="contained"
          color="primary"
          endIcon={<VisibilityIcon />}
          style={{ height: "40px" }}
        >
          View
        </Button>
      </div>

      <div className="line1edit">
        <div>
          <div>
            <div>
              <InputLabel
                id="mobileCodeLable"
                style={{ fontWeight: "bold", color: "#000" }}
              >
                {" "}
                Mobile Number{" "}
              </InputLabel>
            </div>
            <div style={{ marginTop: "10px" }}>
              <TextField
                id="standard-basic"
                value={"+" + formObject.countrycode + " " + formObject.mobile}
                onChange={handleChange}
                name="mobile"
                disabled
              />
            </div>
          </div>
        </div>

        <div>
          <div>
            <InputLabel
              id="firstNameLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              First Name
            </InputLabel>
          </div>

          <TextField
            id="firstNameField"
            name="fname"
            value={formObject.fname}
            onChange={handleChange}
            style={
              validationState.hasOwnProperty("fname") &&
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            error={
              validationState["fname"] &&
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
            }
            helperText={
              validationState["fname"] &&
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
                ? validationState["fname"]["message"]
                : ""
            }
          />
        </div>

        <div>
          <div>
            <InputLabel
              id="lastNameLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Last Name
            </InputLabel>
          </div>

          <TextField
            id="lastNameField"
            name="lname"
            value={formObject.lname}
            onChange={handleChange}
            style={
              validationState.hasOwnProperty("lname") &&
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            error={
              validationState["lname"] &&
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
            }
            helperText={
              validationState["lname"] &&
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
                ? validationState["lname"]["message"]
                : ""
            }
          />
        </div>
      </div>

      <div className="line1edit">
        <div>
          <div>
            <InputLabel
              id="emailIDLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Email ID
            </InputLabel>
          </div>
          <div style={{ marginTop: "10px" }}>
            <TextField
              id="emailIDField"
              name="email"
              value={formObject.email}
              onChange={handleChange}
              disabled
            />
          </div>
        </div>

        <div>
          <div>
            <InputLabel
              id="emailIDLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Assigned BGT
            </InputLabel>
          </div>
          <div style={{ marginTop: "10px" }}>
            <TextField
              id="emailIDField"
              name="email"
              value={formObject.bgt}
              onChange={handleChange}
              disabled
            />
          </div>
        </div>
        <div>
          <div>
            <InputLabel
              id="emailIDLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Signup Date
            </InputLabel>
          </div>

          <div style={{ marginTop: "10px" }}>
            <TextField
              disabled
              id="datePickerId"
              //label="Select Date"
              type="date"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              //format="YYYY-MM-DD"
              InputProps={{ inputProps: { min: getToday() } }}
              value={formObject.signup}
              onChange={handleChange}
              name="signup"
              // className={classes.select}
            />
          </div>
        </div>
      </div>

      <div className="line1edit">
        <div>
          <div>
            <InputLabel
              id="communicationSelect"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Preferred Language
            </InputLabel>
          </div>
          <div style={{ marginTop: "10px" }}>
            {questionner
              .filter((obj) => {
                return obj.question === "Communication Preference";
              })
              .map((a, inx) => {
                return (
                  <Select
                    displayEmpty
                    labelId="communicationSelect"
                    id="communicationSelect"
                    onChange={handleChange}
                    value={formObject.communication}
                    name="communication"
                  >
                    <MenuItem value="">Select</MenuItem>
                    {a.options.map((option, index) => {
                      // (formObject.communication);
                      return (
                        <MenuItem value={option.values}>{option.name}</MenuItem>
                      );
                    })}
                  </Select>
                );
              })}
          </div>
        </div>

        <div>
          <div>
            <InputLabel
              id="emailIDLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Assigned CDT
            </InputLabel>
          </div>
          <div style={{ marginTop: "10px" }}>
            {/* <TextField id="emailIDField" name="assigned_exec" value={formObject.assigned_exec} onChange={handleChange} disabled /> */}
            <Select
              displayEmpty
              labelId="assignexeSelect"
              id=" Assign_exe_value"
              onChange={handleChangeAssignExe}
              name="a Assign_exe_value"
              value={settingdata.Assign_exe_value}
            >
              <MenuItem value="">{formObject.assigned_exec}</MenuItem>
              {rmNames.map((item) => {
                return <MenuItem value={item.id}>{item.empfname}</MenuItem>;
              })}
            </Select>
          </div>
        </div>

        <div>
          <div item xs={12} sm={5} md={5}>
            <InputLabel
              className={classes.lableColor}
              id="locatonLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Prospect State
            </InputLabel>
          </div>
          <div item xs={12} sm={2} md={1} style={{ marginBottom: "10px" }}>
            <TextField
              size="small"
              id="standard-basic"
              placeholder="Enter"
              value={formObject.loc_state}
              onChange={handleChange}
              name="loc_state"
            />
          </div>
        </div>
      </div>
      <div className="line1edit">
        <div>
          <div>
            <InputLabel
              id="statusLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              CDT Status
            </InputLabel>
          </div>

          <div style={{ marginTop: "10px" }}>
            <Select
              displayEmpty
              labelId="statusLable"
              id="statusSelect"
              onChange={handleChangeCdtStatus}
              value={cdtStatusNew}
              name="status"
            >
              <MenuItem value="">
                {formObject.cdt_status ? formObject.cdt_status : "Select"}
              </MenuItem>
              {cdtStatusDropDown.map((option, index) => {
                // (option);
                // (formObject.status)
                return <MenuItem value={option.value}>{option.name}</MenuItem>;
              })}
            </Select>
          </div>
        </div>
        <div>
          <div>
            <InputLabel
              id="statusLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Check-in Status :
            </InputLabel>
          </div>
          <div style={{ marginTop: "10px" }}>
            <Select
              displayEmpty
              labelId="statusLable"
              id="statusSelect"
              onChange={handleChangeCheckInStatus}
              value={checkInStatusNew}
              name="checkInStatus"
            >
              <MenuItem value="">
                {formObject.checkin_status
                  ? formObject.checkin_status
                  : "Select"}
              </MenuItem>
              {checkInStatusDropdown.map((option, index) => {
                // (option);
                // (formObject.status)
                return <MenuItem value={option.value}>{option.name}</MenuItem>;
              })}
            </Select>
          </div>
        </div>
        <div>
          <div item xs={12} sm={5} md={5}>
            <InputLabel
              className={classes.lableColor}
              id="locatonLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              BGT Status
            </InputLabel>
          </div>
          <div item xs={12} sm={2} md={1} style={{ marginBottom: "10px" }}>
            <TextField
              size="small"
              id="standard-basic"
              placeholder="Enter"
              value={formObject.bgtStatus ? formObject.bgtStatus : "N/A"}
              onChange={handleChange}
              name="bgtStatus"
              disabled
            />
          </div>
        </div>
      </div>

      <div className="line2edit">
        <div>
          <div>
            <div>
              <InputLabel
                id="emailIDLable"
                style={{ fontWeight: "bold", color: "#000" }}
              >
                Assigned CRT
              </InputLabel>
            </div>
            <div style={{ marginTop: "10px" }}>
              {/* <TextField id="emailIDField" name="assigned_exec" value={formObject.assigned_exec} onChange={handleChange} disabled /> */}
              <Select
                displayEmpty
                labelId="assignexeSelect"
                id=" Assign_exe_value"
                onChange={handleChangeAssigncrt}
                name="a Assign_exe_value"
                value={settingdata.Assign_exe_value_crt}
              >
                <MenuItem value="">{formObject.crt}</MenuItem>
                {crtName.map((item) => {
                  return <MenuItem value={item.id}>{item.empfname}</MenuItem>;
                })}
              </Select>
            </div>
          </div>
        </div>
        <div>
          <div item xs={12} sm={5} md={5}>
            <InputLabel
              className={classes.lableColor}
              id="locatonLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Prospect Country
            </InputLabel>
          </div>
          <div item xs={12} sm={3} md={3} style={{ marginTop: "10px" }}>
            <Select
              disabled
              displayEmpty
              labelId="Country"
              id="Country"
              className={classes.select}
              onChange={handleChange}
              value={formObject.loc_country ? formObject.loc_country : ""}
              name="loc_country"
              style={{ border: "none" }}
            >
              <MenuItem value="">Select</MenuItem>
              {countryDropDown.map((option) => {
                return (
                  <MenuItem value={option.locname}>{option.locname}</MenuItem>
                );
              })}
            </Select>
          </div>
        </div>
        <div>
          <div>
            <div>
              <InputLabel
                id="statusLable"
                style={{ fontWeight: "bold", color: "#000" }}
              >
                CRT Status
              </InputLabel>
            </div>

            <div style={{ marginTop: "10px" }}>
              <Select
                displayEmpty
                labelId="statusLable"
                id="statusSelect"
                onChange={handleCRTstatus}
                value={CRTstatus}
                name="crt_status"
              >
                <MenuItem value="">
                  {formObject.crt_status ? formObject.crt_status : "Select"}
                </MenuItem>
                {dropdownCRTstatus.map((option, index) => {
                  // (option);
                  // (formObject.status)
                  return (
                    <MenuItem value={option.value}>{option.name}</MenuItem>
                  );
                })}
              </Select>
            </div>
          </div>
        </div>
      </div>
      <div style={{ float: "right", marginTop: 15 }}>
        <div>
          {formObject.addProspectBtnClick ? (
            <Button
              variant="contained"
              color="primary"
              disabled
              className="addBtn"
            >
              Save
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className="addBtn"
            >
              Save
            </Button>
          )}
        </div>
      </div>
      <Grid container className={classes.gridDevider}>
        <Grid item xs={12} sm={5} md={5}>
          {/* <Typography color="textPrimary" variant="h5" >User Questionnaire</Typography> */}
        </Grid>
      </Grid>
      {userQuestionnaire.map((question) => {
        return question.display ? (
          <Grid container className={classes.paper}>
            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
              <InputLabel
                className={classes.lableColor}
                id={question.lable + "label"}
              >
                {question.lable}
                {question.imp && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                )}
              </InputLabel>
            </Grid>
            <Grid item lg={5} md={5} sm={5}>
              {question.filedType === "dropDown" ? (
                questionner
                  .filter((obj) => {
                    return obj.question === question.lable;
                  })
                  .map((a) => {
                    return (
                      <Select
                        displayEmpty
                        labelId={question.lable + "label"}
                        id="statusSelect"
                        className={classes.select}
                        onChange={handleChange}
                        value={
                          formObject[question.value]
                            ? formObject[question.value]
                            : ""
                        }
                        name={question.value}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {a.options.map((option) => {
                          return (
                            <MenuItem
                              value={option.values}
                              key={option.values + "pd"}
                            >
                              {option.name}
                            </MenuItem>
                          );
                        })}
                        )
                      </Select>
                    );
                  })
              ) : (
                <TextField
                  label="Enter"
                  variant="outlined"
                  value={formObject[question.value]}
                  name={question.value}
                  onChange={handleChange}
                  className={classes.select}
                  disabled={
                    question.disableCondition &&
                    formObject.hasOwnProperty(question.disableCondition) &&
                    formObject[question.disableCondition] ===
                      question.disableValue
                  }
                  style={
                    validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"]
                      ? { paddingBottom: 20 }
                      : {}
                  }
                  error={
                    validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"]
                  }
                  helperText={
                    validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"]
                      ? validationState[question.value]["message"]
                      : ""
                  }
                />
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        );
      })}
      {/* <Grid container className={classes.paper}>
                <Grid item xs={12} sm={5} md={5} >
                    <InputLabel className={classes.lableColor} id="locatonLable">Prospect Location</InputLabel>
                </Grid>

                <Grid item xs={12} sm={2} md={1} >
                    <TextField id="standard-basic" label="State" value={formObject.loc_state} onChange={handleChange} name="loc_state" />
                </Grid>
                <Grid item xs={12} sm={3} md={3} >
                    <Select displayEmpty labelId="Country" id="Country" className={classes.select} onChange={handleChange} value={(formObject.loc_country) ? formObject.loc_country : ""} name="loc_country">
                        <MenuItem value="">Select</MenuItem>
                        {countryDropDown.map(option => {
                            return <MenuItem value={option.locname}>{option.locname}</MenuItem>
                        })}
                        )
                    </Select>
                </Grid>
            </Grid> */}
      {/* <Grid container className={classes.submitButton}>
                <Grid item xs={12} sm={5} md={5} >

                </Grid>
                <Grid item xs={12} sm={1} md={1} >
                    <Button variant="contained" color="default" onClick={handleCancel} className="addBtn">Cancel</Button>
                </Grid>

                <Grid item xs={12} sm={1} md={1} >
                    {
                        formObject.addProspectBtnClick ? <Button variant="contained" color="primary" disabled className="addBtn">Save</Button>
                            : <Button variant="contained" color="primary" onClick={handleSubmit} className="addBtn">Save</Button>
                    }
                </Grid>
            </Grid> */}

      <div>
        <h1>
          Tasks{" "}
          <Button
            type="submit"
            color="primary"
            style={{ borderRadius: "100px" }}
            variant="contained"
            size="small"
            onClick={addTask}
          >
            <AddCircleOutlineIcon />
          </Button>
        </h1>
      </div>

      <div style={{ margin: "20px 0px" }}>
        {taskDetails.map((task) => (
          <>
            <div>
              <h2 style={{ color: "#393939" }}>
                {task.tasktype == 1
                  ? "Follow up call"
                  : task.tasktype == 2
                  ? "Follow up mail"
                  : task.tasktype == 3
                  ? "Follow up message"
                  : task.tasktype == 4
                  ? "Call back"
                  : null}
              </h2>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  marginLeft: "20",
                  backgroundColor: "#eaeaea",
                  padding: "0 20px",
                  width: "80%",
                }}
              >
                <h4 style={{ color: "#393939", fontSize: "16px" }}>Comments</h4>
                <p style={{ color: "#000", fontSize: "16px" }}>
                  {task.commments}
                </p>
              </div>

              <div>
                {task.tasktype == 1 || task.tasktype == 4 ? (
                  <button
                    // className="callbutton"
                    className="button"
                    onClick={(e) => callCustomer(e, task.id, task.commments)}
                  >
                    Call{" "}
                    <span style={{ paddingLeft: "9px", display: "flex" }}>
                      <CallIcon />
                    </span>
                  </button>
                ) : task.tasktype == 2 ? (
                  <button
                    // className="callbutton"
                    className="button"
                    onClick={(e) => sendEmail(e, task.id, task.commments)}
                  >
                    Email{" "}
                    <span style={{ paddingLeft: "9px", display: "flex" }}>
                      <EmailIcon />
                    </span>
                  </button>
                ) : task.tasktype == 3 ? (
                  <>
                    <label
                      for="itag"
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ccc",
                        padding: "0px 5px",
                      }}
                    >
                      Choose file
                    </label>
                    <input
                      id="itag"
                      //  className="choosefile"
                      style={{ width: 100, display: "none" }}
                      type="file"
                      onChange={(e) => {
                        handleImageChange(e, task.id);
                      }}
                      name="proof"
                      multiple={false}
                      accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                    />{" "}
                    <br />
                    <br />
                    <button
                      //  className="choosefile"
                      onClick={(e) => sendfile(e, task.id, task.commments)}
                      className="button"
                    >
                      Upload
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </>
        ))}
      </div>

      <CommunicationTimeLine />
    </>
  );
}

export default EditInvestornew;
